(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["team"] && !Shopify.designMode) return;
  try {
    
/**
 * Team section — card flip interaction.
 * Expects explicit .team-card markup from blocks/team-member.liquid.
 */
(function () {
  const FLIPPED_CLASS = 'is-flipped';

  /**
   * @param {HTMLElement} card
   * @param {boolean} flipped
   */
  function setFlipped(card, flipped) {
    const readBio = card.querySelector('[data-team-read-bio]');
    card.classList.toggle(FLIPPED_CLASS, flipped);
    if (readBio) {
      readBio.setAttribute('aria-expanded', flipped ? 'true' : 'false');
    }
  }

  /**
   * @param {HTMLElement} card
   */
  function initCard(card) {
    if (card.dataset.teamCardInit === 'true') return;
    card.dataset.teamCardInit = 'true';

    const readBio = card.querySelector('[data-team-read-bio]');
    const closeBio = card.querySelector('[data-team-close-bio]');
    if (!readBio || !closeBio) return;

    readBio.addEventListener('click', () => {
      setFlipped(card, true);
      closeBio.focus();
    });

    closeBio.addEventListener('click', () => {
      setFlipped(card, false);
      readBio.focus();
    });

    card.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && card.classList.contains(FLIPPED_CLASS)) {
        setFlipped(card, false);
        readBio.focus();
      }
    });
  }

  function initTeamCards(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-team-card]').forEach((card) => {
      if (card instanceof HTMLElement) initCard(card);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initTeamCards(document));
  } else {
    initTeamCards(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initTeamCards(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
